var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-row", { staticClass: "el-row-line" }, [_c("PageInfo")], 1),
      _vm._v(" "),
      _c("el-row", { staticStyle: { "margin-top": "20px" } }, [
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.appList, function (item, index) {
            return _c("div", { key: item.id }, [
              item.state
                ? _c(
                    "div",
                    {
                      staticClass: "card",
                      style: { background: _vm.colorList[index % 4] },
                      on: {
                        click: function ($event) {
                          return _vm.enterSystem(item.app_domain)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "card-title" }, [
                        _c("h3", [_vm._v(_vm._s(item.app_name))]),
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "card-img",
                        attrs: {
                          src: require("../../assets/manage.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", { staticStyle: { color: "aliceblue" } }, [
                          _vm._v(_vm._s(item.des)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "card-bottom",
                          style: { background: _vm.bgColorList[index % 4] },
                        },
                        [_vm._v("\n            进入\n          ")]
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }